// // import { createContext, useContext, useState, useEffect } from 'react'
// // import {jwtDecode} from 'jwt-decode'

// // const AuthContext = createContext()

// // export const AuthProvider = ({ children }) => {
// //   const [user, setUser] = useState(null)
// //   const [loading, setLoading] = useState(true)

// //   useEffect(() => {
// //     const token = localStorage.getItem('token')
// //     if (token) {
// //       try {
// //         const decoded = jwtDecode(token)
// //         setUser(decoded)  // Must include: id, email, role
// //       } catch (err) {
// //         localStorage.removeItem('token')
// //       }
// //     }
// //     setLoading(false)
// //   }, [])

// //   const login = (token) => {
// //     localStorage.setItem('token', token)
// //     const decoded = jwtDecode(token)
// //     setUser(decoded)
// //   }

// //   const logout = () => {
// //     localStorage.removeItem('token')
// //     setUser(null)
// //   }

// //   return (
// //     <AuthContext.Provider value={{ user, login, logout, loading }}>
// //       {children}
// //     </AuthContext.Provider>
// //   )
// // }

// // export const useAuth = () => useContext(AuthContext)

// import { createContext, useContext, useState, useEffect } from "react";
// import { jwtDecode } from "jwt-decode";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [role, setRole] = useState(null)
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       try {
//         const decoded = jwtDecode(token);
//         setUser(decoded); // Must include: id, email, role
//       } catch (err) {
//         console.error("Invalid token:", err);
//         localStorage.removeItem("token");
//       }
//     }
//     setLoading(false);
//   }, []);

//   const login = (token) => {
//     localStorage.setItem("token", token);
//     const decoded = jwtDecode(token);
//     setUser(decoded);
//   };

//   const logout = () => {
//     localStorage.removeItem("token");
//     setUser(null);
//   };

//   const updateUser = (data) => {
//     setUser(data);
//     setRole(data.role);
//   };


//   return (
//     <AuthContext.Provider value={{ user, login, logout, loading }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// // Custom hook
// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// };

import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import api from "../api/client";
import { telegramLogin, getCurrentUser } from "../api/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount: read token + decode, then refresh from API
  useEffect(() => {
    const bootstrap = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const decoded = jwtDecode(token);
        api.defaults.headers.Authorization = `Bearer ${token}`;

        try {
          const { data } = await getCurrentUser();
          const freshUser = data.user;
          setUser({
            id: freshUser.id,
            email: freshUser.email,
            role: freshUser.role,
            termsAccepted: freshUser.termsAccepted ?? !!freshUser.termsAcceptedAt,
            avatarUrl: decoded.avatarUrl || null,
          });
          setRole(freshUser.role?.toUpperCase());
        } catch {
          setUser({
            ...decoded,
            avatarUrl: decoded.avatarUrl || null,
            termsAccepted: decoded.termsAccepted ?? true,
          });
          setRole(decoded.role?.toUpperCase());
        }
      } catch (err) {
        console.error("Invalid token:", err);
        localStorage.removeItem("token");
      } finally {
        setLoading(false);
      }
    };

    bootstrap();
  }, []);

  const login = useCallback((token, userData, navigate) => {
    localStorage.setItem("token", token);
    const decoded = jwtDecode(token);
    const updatedUser = {
      ...decoded,
      ...userData,
      termsAccepted: userData?.termsAccepted ?? true,
    };
    setUser(updatedUser);
    setRole(userData.role?.toUpperCase());
    api.defaults.headers.Authorization = `Bearer ${token}`;

    if (navigate) {
      if (updatedUser.termsAccepted === false) {
        navigate("/accept-policies", { replace: true });
        return;
      }
      const target = userData.role?.toUpperCase() === "ADMIN"
        ? "/admin/dashboard"
        : "/";
      navigate(target, { replace: true });
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    delete api.defaults.headers.Authorization;
    setUser(null);
    setRole(null);
  }, []);

  const updateUser = useCallback((data) => {
    setUser((prev) => ({ ...prev, ...data }));
    if (data.role) {
      setRole(data.role.toUpperCase());
    }
    // Optional: update token if new one is provided
    if (data.token) {
      localStorage.setItem("token", data.token);
      api.defaults.headers.Authorization = `Bearer ${data.token}`;
    }
  }, []);

  const loginWithTelegram = useCallback(async (initData, policies = {}) => {
    try {
      const { data } = await telegramLogin({ initData, ...policies });
      login(data.token, data.user);
      return data.user;
    } catch (error) {
      console.error("Telegram login failed:", error);
      throw error;
    }
  }, [login]);

  const value = useMemo(() => ({
    user,
    role,
    loading,
    login,
    logout,
    updateUser,
    loginWithTelegram
  }), [user, role, loading, login, logout, updateUser, loginWithTelegram]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used within AuthProvider");
  return context;
};